module.exports = __webpack_public_path__ + "img/Group-51.cfb1ebb6.png";